module.exports = __webpack_public_path__ + "img/services-reservations.a6368b5e.svg";